import { DTableCategory } from "./d-table-category";

export interface DTableCategoryContainer {
	readonly items: DTableCategory[];
}
